module.exports = __webpack_public_path__ + "static/media/Ruby-pup.f316c792.jpg";